import ZkLangeChange from './src/main'
ZkLangeChange.install = function (Vue) {
  Vue.component(ZkLangeChange.name, ZkLangeChange)
}
export default ZkLangeChange



// WEBPACK FOOTER //
// ./src/cdpBase/baseComponents/langChange/index.js